/**
 * It's lit()! For setting CSS class-names using template literals
 */

const extraWhitespaceRegex = /\s+/gm

/**
 * Tagged template function to format CSS class names so they are rendered in a more
 * standard way in the DOM, intended to avoid long concatenations of tailwind classes
 * with extraneous whitespace.
 * Inspired by https://github.com/netlify/classnames-template-literals

 Example Usage:
   lit`
     bg-black
     text-white
     ${someState && 'bg-pink'}
  `

  Output if `someState` is true:
    "bg-black text-white bg-pink"
 */
export function lit(strings: TemplateStringsArray, ...values: any[]) {
    return strings
        .reduce<string[]>((formattedClassNames, str, i) => {
            formattedClassNames.push(
                str.replace(extraWhitespaceRegex, ' ').trim(),
                values[i]
            )
            return formattedClassNames
        }, [])
        .filter(Boolean) // filter out empty and falsey values
        .join(' ')
}
